/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPentagonPlus = createReactComponent("pentagon-plus", "IconPentagonPlus", [
  [
    "path",
    {
      d: "M12.5 21.005h-5.458a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-.78 2.401",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }]
]);

export { IconPentagonPlus as default };
//# sourceMappingURL=IconPentagonPlus.js.map
